const CardFormErrorModal = ({ error, message, onClose }) => {
  return (
    <>
      <div className="credit-error-wrap">
        <div className="popup">
          <div
            className="title-error"
            dangerouslySetInnerHTML={{ __html: error }}
          />
          <div className="text" dangerouslySetInnerHTML={{ __html: message }} />
          <div className="button credit-error-btn" onClick={() => onClose()}>
            <ul>
              <li>OK</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardFormErrorModal;
